var map = {
	"./2.jpg": 5659,
	"./3.jpg": 8532,
	"./4.jpg": 6361,
	"./5.jpg": 1447,
	"./Semi-compliant PTCA Balloon Dilatation Catheter.png": 824,
	"./aboutus.jpg": 3478,
	"./logo.png": 7946,
	"./wave.svg": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;